import { httpClient } from './http-client';

/**
 * Holdings-baseline API client: snapshot-mode onboarding for an investment
 * account, and its one-way graduation into transaction tracking.
 */

export interface BaselineLine {
  symbol: string;
  /** Decimal strings, as the backend stores them. */
  quantity: string;
  price: string;
  currency: string;
}

export interface HoldingsBaseline {
  id: string;
  account_id: string;
  /** RFC3339 timestamp from the backend; slice(0, 10) for the date. */
  as_of: string;
  notes?: string | null;
  lines: BaselineLine[];
  created_at: string;
}

export interface PutBaselineRequest {
  as_of: string; // YYYY-MM-DD
  notes?: string;
  lines: BaselineLine[];
}

export class HoldingsBaselineService {
  /** Returns null when the account has no baseline (a 404 from the API). */
  static async get(accountId: string): Promise<HoldingsBaseline | null> {
    try {
      return await httpClient.get<HoldingsBaseline>(`/accounts/${accountId}/holdings-baseline`);
    } catch (e: any) {
      if (e?.code === '404' || e?.code === 404) return null;
      throw e;
    }
  }

  static async put(accountId: string, body: PutBaselineRequest): Promise<HoldingsBaseline> {
    return httpClient.put<HoldingsBaseline>(`/accounts/${accountId}/holdings-baseline`, body);
  }

  /** Converts the snapshot into TRANSFER_IN trades and flips tracking mode. */
  static async graduate(accountId: string): Promise<void> {
    await httpClient.post(`/accounts/${accountId}/graduate`);
  }
}
